module.exports = __webpack_public_path__ + "img/ic-card-tick.75a4a998.svg";